import useSWR from "swr";
import settings from "../../../../constants/settings";
import useSWRFetcher from "../fetcher";
import { ProductionStatus } from "../../../../reducers/uploadedBoard";

interface ShipmentHistoryRecord {
  shipment_id: string | null;
  datetime_created: string;
  action: string;
  user_id: string | null;
  ship_date: string | null;
  num_boards: number;
  production_status: ProductionStatus;
}

interface ShipmentHistoryResponse {
  records: ShipmentHistoryRecord[];
}

export default function useShipmentHistory(boardId: string) {
  const fetcher = useSWRFetcher<ShipmentHistoryResponse>(undefined);
  const { data } = useSWR<ShipmentHistoryResponse>(
    `${settings.api_url}/boards/${boardId}/shipments/history`,
    fetcher,
  );

  return {
    shipmentHistory: data || null,
  };
}
